import Vue from 'vue'
import Modal from 'objects/modal/modal'
import ProductImage from 'objects/product-image/product-image'

import withRender from './multi-items.html'
import './multi-items.scss'

export default withRender((Vue as any).extend({
  data() {
    return { showMultiItemSearch: false }
  },
  props: {
    multiItems: { type: Array },
    promptText: { type: String },
    sku: { type: String }
  },
  components: {
    // tslint:disable-next-line
    'tt-multi-item-search':  () => import(/* webpackChunkName: 'multi-item-search' */ 'components/question/multi-item-search'),
    'tt-modal': Modal,
    'tt-product-image': ProductImage
  },
  computed: {
    searchExcludedCatItemIds() {
      return this.multiItems.map(item => item.id)
    }
  },
  methods: {
    addItemsAndClose(items) {
      this.$emit('addItems', items)
      this.closeSearch()
    },
    openSearch() {
      this.showMultiItemSearch = true
    },
    closeSearch() {
      this.showMultiItemSearch = false
      this.$refs.openSearchBtn.$el.focus()
    },
    removeItem(item) {
      this.$emit('removeItem', item)
    }
  }
}))
